import LayoutFront from "layout/LayoutFront";
import LoginCenter from "view/Login/LoginCenter";

import Register from "view/Register";
import Home from "view/Home/Home";
import AdminUser_List from "view/AdminUser/AdminUser_List";
import AdminUser_From from "view/AdminUser/AdminUser_From";
import Recruitment_List from "view/UserRecruitment/Recruitment_List";
import Recruitment_From from "view/UserRecruitment/Recruitment_From";
import Report from "view/Report/Report";

const route = [
    {
        exact: true,
        path: "/",
        component: LoginCenter,
    },
    {
        exact: true,
        path: "/Login",
        component: LoginCenter,
    },
    {
        exact: true,
        path: "/RegisterRecruitment",
        component: Register,
        layout: null,
        props: { MenuID_Selected: 0 }
    },
    {
        exact: true,
        path: "/Home",
        component: Home,
        layout: LayoutFront,
        props: { MenuID_Selected: 1 }
    },
    {
        exact: true,
        path: "/AdminUser",
        component: AdminUser_List,
        layout: LayoutFront,
        props: { MenuID_Selected: 2 }
    },
    {
        exact: true,
        path: "/AdminUser_From",
        component: AdminUser_From,
        layout: LayoutFront,
        props: { MenuID_Selected: 3 }
    },
    {
        exact: true,
        path: "/UserRecruitment",
        component: Recruitment_List,
        layout: LayoutFront,
        props: { MenuID_Selected: 4 }
    }, 
    {
        exact: true,
        path: "/UserRecruitment_From",
        component: Recruitment_From,
        layout: LayoutFront,
        props: { MenuID_Selected: 5 }
    }, 
    {
        exact: true,
        path: "/Report",
        component: Report,
        layout: LayoutFront,
        props: { MenuID_Selected: 6 }
    },       
];

export default route;